export enum TabOptions {
  DETAILS = "details",
  HISTORY = "history",
}
